type MentionToken = { user_id: number; name: string };
const MENTION_REGEX = /《\{[\s\S]*?\}》/g;

export default function RenderMessageContent(content: string) {
  if (!content) return null;

  const out: React.ReactNode[] = [];
  let lastIndex = 0;

  console.log("Looking for match: ", content);

  for (const match of content.matchAll(MENTION_REGEX)) {
    console.log("Match found:", match);
    const start = match.index ?? 0;
    const raw = match[0];

    // push preceding plain text
    if (start > lastIndex) {
      out.push(content.slice(lastIndex, start));
    }

    // parse mention JSON inside 《 ... 》
    const jsonText = raw.slice(1, -1); // remove the outer 《 and 》
    let mention: MentionToken | null = null;

    try {
      const obj = JSON.parse(jsonText);
      if (obj && typeof obj.user_id === 'number' && typeof obj.name === 'string') {
        mention = { user_id: obj.user_id, name: obj.name };
      }
    } catch {
      console.warn("Failed to parse mention JSON:", jsonText);
      // fall through -> treat as plain text
    }

    if (!mention) {
      out.push(raw);
    } else {
      out.push(
        <span
          key={`mention-${start}-${mention.user_id}`}
          style={{
            display: 'inline-block',
            padding: '2px 8px',
            margin: '0 2px',
            borderRadius: '999px',
            background: '#e6f0ff',     // light blue-ish
            color: '#6b3fd6',          // slightly purple text
            fontWeight: 700,
            lineHeight: 1.4,
            verticalAlign: 'baseline',
            userSelect: 'text',
          }}
          title={`user_id: ${mention.user_id}`}
        >
          @{mention.name}
        </span>,
      );
    }

    lastIndex = start + raw.length;
  }

  // trailing plain text
  if (lastIndex < content.length) {
    out.push(content.slice(lastIndex));
  }

  console.log("Final rendered content:", out);

  return <>{out}</>;
}
